import { render, staticRenderFns } from "./CardVentas.vue?vue&type=template&id=8c9d85f0&scoped=true"
import script from "./CardVentas.vue?vue&type=script&lang=js"
export * from "./CardVentas.vue?vue&type=script&lang=js"
import style0 from "./CardVentas.vue?vue&type=style&index=0&id=8c9d85f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9d85f0",
  null
  
)

export default component.exports